import {type UrlRule} from "../types.ts";

import {mapParam} from "./map-param.ts";

/**
 * Set the param to the given default if it is not already set.
 *
 * This looks at the value of the given param, and if it is not present,
 * it will set the value of the param in the URL being constructed to the
 * given default value.
 *
 * This is useful for ensuring that required params have a value.
 *
 * @param paramName The name of the param to populate.
 * @param defaultValue A function to that returns the value to set the param to
 * if it is not already set. This is only executed if the param being defaulted
 * is not already set.
 * @returns A URL rule that sets the given param to the result of the
 * default value function if the param is not already set.
 */
export const defaultParam = (
    paramName: string,
    defaultValue: () => string,
): UrlRule =>
    mapParam(paramName, (currentValue) => currentValue ?? defaultValue());
